import React, { useState } from 'react';
import { toast } from 'react-hot-toast';

const Beneficios = () => {
  const [filtros, setFiltros] = useState({
    page: 1,
    limit: 10,
    status: '',
    tipo: '',
    colaborador: ''
  });
  
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('create');
  // const [beneficioSelecionado, setBeneficioSelecionado] = useState(null);
  const [formData, setFormData] = useState({
    colaborador: '',
    tipo: 'vale_refeicao',
    valor: '',
    dataInicio: '',
    dataFim: '',
    status: 'ativo',
    observacoes: ''
  });


  // Simular dados para demonstração
  const beneficios = [
    {
      _id: '1',
      colaborador: 'João Silva',
      tipo: 'vale_refeicao',
      valor: 'R$ 15,00',
      dataInicio: '2024-01-01',
      dataFim: '2024-12-31',
      status: 'ativo',
      observacoes: 'Vale refeição diário'
    },
    {
      _id: '2',
      colaborador: 'Maria Santos',
      tipo: 'plano_saude',
      valor: 'R$ 150,00',
      dataInicio: '2024-01-01',
      dataFim: '2024-12-31',
      status: 'ativo',
      observacoes: 'Plano de saúde familiar'
    }
  ];

  const handleCreate = () => {
    setModalMode('create');
    // setBeneficioSelecionado(null);
    setFormData({
      colaborador: '',
      tipo: 'vale_refeicao',
      valor: '',
      dataInicio: '',
      dataFim: '',
      status: 'ativo',
      observacoes: ''
    });
    setModalOpen(true);
  };

  const handleEdit = (beneficio) => {
    setModalMode('edit');
    // setBeneficioSelecionado(beneficio);
    setFormData({
      colaborador: beneficio.colaborador,
      tipo: beneficio.tipo,
      valor: beneficio.valor,
      dataInicio: beneficio.dataInicio,
      dataFim: beneficio.dataFim,
      status: beneficio.status,
      observacoes: beneficio.observacoes
    });
    setModalOpen(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aqui você implementaria a lógica de salvar
    toast.success(modalMode === 'create' ? 'Benefício criado com sucesso!' : 'Benefício atualizado com sucesso!');
    setModalOpen(false);
  };

  const getTipoText = (tipo) => {
    const tipos = {
      'vale_refeicao': 'Vale Refeição',
      'vale_transporte': 'Vale Transporte',
      'plano_saude': 'Plano de Saúde',
      'plano_odontologico': 'Plano Odontológico',
      'gympass': 'Gympass',
      'outros': 'Outros'
    };
    return tipos[tipo] || tipo;
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'ativo': return 'bg-green-100 text-green-800';
      case 'inativo': return 'bg-red-100 text-red-800';
      case 'suspenso': return 'bg-yellow-100 text-yellow-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Benefícios</h1>
            <p className="text-gray-600">Gestão de benefícios dos colaboradores</p>
          </div>
          <button
            onClick={handleCreate}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center"
          >
            <span className="mr-2">➕</span>
            Novo Benefício
          </button>
        </div>
      </div>

      {/* Filtros */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <form className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Status
            </label>
            <select
              value={filtros.status}
              onChange={(e) => setFiltros(prev => ({ ...prev, status: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Todos</option>
              <option value="ativo">Ativo</option>
              <option value="inativo">Inativo</option>
              <option value="suspenso">Suspenso</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Tipo
            </label>
            <select
              value={filtros.tipo}
              onChange={(e) => setFiltros(prev => ({ ...prev, tipo: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Todos</option>
              <option value="vale_refeicao">Vale Refeição</option>
              <option value="vale_transporte">Vale Transporte</option>
              <option value="plano_saude">Plano de Saúde</option>
              <option value="plano_odontologico">Plano Odontológico</option>
              <option value="gympass">Gympass</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Colaborador
            </label>
            <input
              type="text"
              placeholder="Nome do colaborador"
              value={filtros.colaborador}
              onChange={(e) => setFiltros(prev => ({ ...prev, colaborador: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          
          <div className="flex items-end">
            <button
              type="submit"
              className="w-full bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-md"
            >
              🔍 Filtrar
            </button>
          </div>
        </form>
      </div>

      {/* Lista de Benefícios */}
      <div className="bg-white rounded-lg shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Colaborador
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Tipo
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Valor
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Período
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {beneficios.map((beneficio) => (
                <tr key={beneficio._id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-gray-900">
                      {beneficio.colaborador}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {getTipoText(beneficio.tipo)}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {beneficio.valor}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {new Date(beneficio.dataInicio).toLocaleDateString('pt-BR')} a {new Date(beneficio.dataFim).toLocaleDateString('pt-BR')}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(beneficio.status)}`}>
                      {beneficio.status.charAt(0).toUpperCase() + beneficio.status.slice(1)}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <div className="flex space-x-2">
                      <button
                        onClick={() => handleEdit(beneficio)}
                        className="text-blue-600 hover:text-blue-900"
                        title="Editar"
                      >
                        ✏️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal de Benefício */}
      {modalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
            <div className="mt-3">
              <h3 className="text-lg font-medium text-gray-900 mb-4">
                {modalMode === 'create' ? 'Novo Benefício' : 'Editar Benefício'}
              </h3>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Colaborador
                  </label>
                  <input
                    type="text"
                    value={formData.colaborador}
                    onChange={(e) => setFormData(prev => ({ ...prev, colaborador: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Tipo
                  </label>
                  <select
                    value={formData.tipo}
                    onChange={(e) => setFormData(prev => ({ ...prev, tipo: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  >
                    <option value="vale_refeicao">Vale Refeição</option>
                    <option value="vale_transporte">Vale Transporte</option>
                    <option value="plano_saude">Plano de Saúde</option>
                    <option value="plano_odontologico">Plano Odontológico</option>
                    <option value="gympass">Gympass</option>
                    <option value="outros">Outros</option>
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Valor
                  </label>
                  <input
                    type="text"
                    value={formData.valor}
                    onChange={(e) => setFormData(prev => ({ ...prev, valor: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Ex: R$ 15,00"
                    required
                  />
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Data Início
                    </label>
                    <input
                      type="date"
                      value={formData.dataInicio}
                      onChange={(e) => setFormData(prev => ({ ...prev, dataInicio: e.target.value }))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Data Fim
                    </label>
                    <input
                      type="date"
                      value={formData.dataFim}
                      onChange={(e) => setFormData(prev => ({ ...prev, dataFim: e.target.value }))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Status
                  </label>
                  <select
                    value={formData.status}
                    onChange={(e) => setFormData(prev => ({ ...prev, status: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  >
                    <option value="ativo">Ativo</option>
                    <option value="inativo">Inativo</option>
                    <option value="suspenso">Suspenso</option>
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Observações
                  </label>
                  <textarea
                    value={formData.observacoes}
                    onChange={(e) => setFormData(prev => ({ ...prev, observacoes: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    rows="3"
                  />
                </div>
                
                <div className="flex justify-end space-x-3">
                  <button
                    type="button"
                    onClick={() => setModalOpen(false)}
                    className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                  >
                    {modalMode === 'create' ? 'Criar' : 'Atualizar'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Beneficios;